(function ($) {
  Drupal.behaviors.basicInlineFormatterV1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $thismodule = $('.js-basic-inline-formatter', context);

      $thismodule.each(function () {
        var $module = $(this);
        var $blocks = $module.find('.js-basic-inline-formatter__blocks');
        var $kids = $blocks.children();
        var blockWidth;

        if ($kids.length > 0) {
          blockWidth = 100 / $kids.length;
          $kids.css('width', blockWidth + '%');
        }
      });
    }
  };
})(jQuery);
